var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eNFguaA4Lhq1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 300",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.103764 0 0 1.202734-15.564606-31.134658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.12066,105.48729c-4.99963,11.20606-23.00296,28.70161-34.47297,37.29164c6.204,21.90417,18.71199,45.81445,12.92736,52.21641-6.87507,5.43716-30.00324-10.77706-53.57505-25.34777v-115.62639c8.48306,7.64241,23.25273,34.68793,29.74814,46.68045l45.37252,4.78566Z",
    transform: "matrix(1.809071 0 0 1.755946-121.360653-68.971667)",
    fill: "#e3822e",
    stroke: "#e3822e",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.251855,100.701624C126.747273,88.709098,141.516939,61.663575,150,54.02117l-.000004,115.626393c-23.571809,14.570713-46.699983,30.784933-53.575048,25.347773-5.784626-6.401961,6.723363-30.312236,12.927364-52.216409-11.470004-8.590035-29.473338-26.085579-34.472969-37.291641c13.309055-4.667846,36.116716-4.119012,45.372512-4.785662",
    transform: "matrix(1.809071 0 0 1.755946-121.360646-68.971663)",
    fill: "#f1b945",
    stroke: "#f1b945",
    strokeWidth: 0.6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.4d1e6d36bac0d8c51835ebb44da79465.svg";
export { ForwardRef as ReactComponent };